import { StateCreator } from "zustand"
import toast from "react-hot-toast"

import * as StoreTypes from "@src/types/store"

import QuestionsAdapter from "@pages/Questions/Questions.adapter"
import { apiService } from "@src/services/apiService"

const initState = {
  questions: [],
  paginationQuestions: null,
  questionQueryParams: {
    assistant_id: "",
    per_page: 20,
    page: 1,
  },
}

export const createQuestionsSlice: StateCreator<StoreTypes.StoreState, [], [], StoreTypes.QuestionsSlice> = (
  set,
  get,
) => ({
  ...initState,
  getQuestions: async () => {
    const { questionQueryParams, currentProfile, loading } = get()
    if (loading === "FETCHING_QUESTIONS") return
    try {
      set({ loading: "FETCHING_QUESTIONS" })
      const response = await apiService.questions.getCollection({
        ...questionQueryParams,
        assistant_id: currentProfile!.id,
      })
      const { status, questions } = response.data
      if (!status) {
        throw new Error("Error fetching questions")
      }
      set({
        questions: questions.map(QuestionsAdapter.sanitizeQuestion),
      })
    } catch (error) {
      toast.error("Error fetching questions")
    } finally {
      set({ loading: null })
    }
  },
  resetQuestions: () => {
    set(initState)
  },
})
